<orbit-dialog-header [title]="title()" rounded centerTitle>
  <div class="left-addon" left-addon>
    <orbit-button
      [flat]="true"
      [disabled]="false"
      [label]="closeLabel()"
      (buttonClick)="closeDialog()" />
  </div>
  <div class="right-addon" right-addon></div>
</orbit-dialog-header>

<div class="dialog-content">
  <video class="camera-stream" #videoEl>Video stream not available.</video>
  <canvas class="canvas" [ngClass]="{ transparent: !takenPhoto() }" #canvasEl></canvas>
  @if (streamLoaded()) {
    <div class="button-wrapper">
      @if (!takenPhoto()) {
        <orbit-button
          class="camera-shutter-button"
          [label]="'SHARED.TEMPLATES.PHOTO_OVERLAY.TAKE' | translate"
          [icon]="faCamera"
          (buttonClick)="takePhoto()" />
      } @else {
        <orbit-button
          class="camera-shutter-button"
          [label]="'SHARED.TEMPLATES.PHOTO_OVERLAY.RETAKE' | translate"
          [icon]="faTrashXmark"
          (buttonClick)="clearPhoto()" />
        <orbit-button
          class="camera-shutter-button"
          [label]="'Send photo'"
          [icon]="faPaperPlane"
          (buttonClick)="handleSendButton()" />
      }
    </div>

    @if (takenPhoto()) {
      <div class="backdrop"></div>
      <img
        class="photo"
        [src]="takenPhoto()"
        #photoEl
        [alt]="'SHARED.TEMPLATES.PHOTO_OVERLAY.ALT' | translate" />
    }
  }
</div>
